<template>
  <div class="main">
    <div class="actions">
      <button @click="$router.go(-1)" style="
          border: 0;
          background: transparent;
          font-size: 14px;
          text-decoration: none;
          line-height: 30px;
          color: #98c14b;
          display: flex;
        ">
        <p>
          <a-icon type="double-left" />
        </p>
        <p>Go Back</p>
      </button>
    </div>
    <h3 style="font-size: 28px; line-height: 45px">
      {{ wareHouseDetails.name }}
    </h3>
    <div>
      <div class="card-container">
        <a-tabs type="card">
          <a-tab-pane key="1">
            <span slot="tab"> Inventory </span>
            <div class="requestActions">
              <!-- <a-form-model
                                :model="orderform"
                            >
                                <a-form-model-item>
                                    <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                        <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                    </a-input>
                                </a-form-model-item>
                            </a-form-model> -->

              <a-button @click="exportExcell" style="
                  height: 38px;
                  margin-right: 10px;
                  border-raduis: 5px;
                  background: #418a49;
                  color: #fff;
                " icon="export">
                Export
              </a-button>

              <!-- <a-button @click="showAddNewOrderPage" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                                Request for Inventory
                            </a-button> -->
            </div>
            <div>
              <a-table :columns="inventoryColumns" :data-source="tableInventoryData" :loading="tableLoading"
                :pagination="pagination" class="orderTable">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                  style="padding: 8px">
                  <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                  <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                    Search
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                    Reset
                  </a-button>
                </div>
                <template slot="action" slot-scope="data">
                  <a-dropdown>
                    <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <a-icon style="font-size: 25px" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="showUpdateGroupModal(data)">Edit Group?</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </template>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab"> Received </span>
            <div class="requestActions">
              <a-button @click="showAddInventoryTransferModal" style="
                  height: 38px;
                  margin-right: 10px;
                  border-raduis: 5px;
                  background: #418a49;
                  color: #fff;
                " icon="plus">
                Receive Stock
              </a-button>
              <a-button @click="exportDelivery" style="
                  height: 38px;
                  margin-right: 10px;
                  border-raduis: 5px;
                  background: #418a49;
                  color: #fff;
                " icon="export">
                Export
              </a-button>
            </div>
            <div>
              <a-table :columns="deliveryColumns" :data-source="tableDeliveryData" :loading="tableLoading"
                :pagination="pagination" class="orderTable">
                <template slot="action" slot-scope="data">
                  <a-dropdown>
                    <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <a-icon style="font-size: 25px" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="showDeliveryLines(data)">View More?</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </template>
                <template slot="isRestricted" slot-scope="data">
                  <div v-if="data === 'Yes'">
                    <a-tag color="#87d068">{{ data }}</a-tag>
                  </div>
                  <div v-else>
                    <a-tag color="#f50">{{ data }}</a-tag>
                  </div>
                </template>
                <template slot="clientPurchaseOrderId" slot-scope="data">
                  <div v-if="data.clientPurchaseOrderId">
                    <a>#{{ data.clientPurchaseOrderId }}</a>
                    <br />
                    <a class="linktag" @click="redirectToPurchaseOrderSingle(data)">View More</a>
                  </div>
                </template>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3">
            <span slot="tab"> Replenishment </span>
            <div class="requestActions">
              <!-- <div class="d-flex justify-content-between pt-1 mr-2">
                <p class="pt-1 mr-2">Filter By Status: </p>
                <a-select style="width: 190px" @change="onInventoryChange">
                    <a-select-option value="all">
                        All
                    </a-select-option>
                    <a-select-option value="0">
                        New
                    </a-select-option>
                    <a-select-option value="1">
                        AwaitingFulfillment
                    </a-select-option>
                    <a-select-option value="2">
                        Fulfilling
                    </a-select-option>
                    <a-select-option value="3">
                        Complete
                    </a-select-option>
                    <a-select-option value="4">
                        Canceled
                    </a-select-option>
                    <a-select-option value="5">
                        Received
                    </a-select-option>
                </a-select>
            </div> -->
              <a-button @click="showAddTransferModal" style="
                  height: 38px;
                  margin-right: 10px;
                  border-raduis: 5px;
                  background: #418a49;
                  color: #fff;
                " icon="plus">
                Add Replenishment Request
              </a-button>
              <a-button @click="exportTransfer" style="
                  height: 38px;
                  margin-right: 10px;
                  border-raduis: 5px;
                  background: #418a49;
                  color: #fff;
                " icon="export">
                Export
              </a-button>
            </div>
            <div>
              <a-table :columns="transferColumns" :data-source="tableTransferData" :loading="tableLoading"
                :pagination="pagination" class="orderTable">
                <div slot="filterDestinationDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
                  <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />

                  <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                    Search
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                    Reset
                  </a-button>
                </div>

                <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                  style="padding: 8px;display: flex;flex-direction: column;">
                  <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
                    <a-select-option value="all">
                      All
                    </a-select-option>
                    <a-select-option value="0">
                      New
                    </a-select-option>
                    <a-select-option value="1">
                      AwaitingFulfillment
                    </a-select-option>
                    <a-select-option value="2">
                      Fulfilling
                    </a-select-option>
                    <a-select-option value="3">
                      Complete
                    </a-select-option>
                    <a-select-option value="4">
                      Canceled
                    </a-select-option>
                    <a-select-option value="5">
                      Received
                    </a-select-option>
                  </a-select>
                </div>
                <template slot="action" slot-scope="data">
                  <a-dropdown>
                    <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <a-icon style="font-size: 25px" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="showTransfersLines(data)">View More</a>
                      </a-menu-item>
                      <a-menu-item v-show="data.status === 0">
                        <a @click="handleConfirm(data)">Confirm Request</a>
                      </a-menu-item>
                      <a-menu-item v-show="data.status === 1">
                        <a @click="handleDeclineRequest(data)">Decline Request</a>
                      </a-menu-item>
                      <a-menu-item v-show="data.status === 2">
                        <a @click="handleCompleteRequest(data)">Complete Request</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </template>
                <template slot="status" slot-scope="data">
                  <status-component :status="data"></status-component>
                </template>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="4">
            <span slot="tab"> Inventory History </span>
            <InventoryReport :distributionCenter="wareHouseDetails" />
          </a-tab-pane>
        </a-tabs>
      </div>
      <!-- Add Stock Modal -->
      <a-modal class="modalStyle" :visible="addInventoryTransferVisible" width="1000px" :footer="null"
        @cancel="handleAddStockTransferCancel">
        <a-spin :spinning="loading">
          <h3 style="
              display: flex;
              justify-content: center;
              font-weight: bolder;
              padding-top: 10px;
              padding-bottom: 30px;
            ">
            Add Stock
          </h3>
          <div>
            <a-form-model ref="addInventoryTransferForm" :model="addInventoryTransferModel" :rules="rules">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="Select Purchase Order Id" ref="purchaseOrderId" prop="purchaseOrderId">
                    <a-select @change="onPurchaseOrder" v-model="addInventoryTransferModel.purchaseOrderId"
                      placeholder="please select your option">
                      <a-select-option v-for="order in purchaseOrders" :key="order.id" v-bind:value="order.id">
                        Purchase Order id: {{ order.id }} | Supplier Name:
                        {{ order.supplierName }} | Date Created:
                        {{ displayDate(order.created) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <div ref="productHeight" style="height: 400px; overflow-y: scroll">
                <a-row v-for="(request, index) in addInventoryTransferModel.request" :key="request.key" type="flex"
                  justify="space-around">
                  <a-col :span="8">
                    <a-form-model-item label="Product Name" :prop="'request.' + index + '.productId'" :rules="{
        required: true,
        message: 'Please choose your option',
        trigger: 'change',
      }">
                      <a-input-number :min="1" class="rightSideinputText" type="text" v-model="request.productName"
                        disabled />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="3">
                    <a-form-model-item label="Quantity" :prop="'request.' + index + '.quantity'" :rules="{
        required: true,
        message: 'Please enter your quantity',
        trigger: 'change',
      }">
                      <a-input-number :min="1" class="rightSideinputText" type="number" :disabled="request.disabled"
                        v-model="request.quantity" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="3">
                    <a-form-model-item label="Batch Number" :prop="'request.' + index + '.batchNumber'" :rules="{
        required: request.required,
        message: 'Please enter your number',
        trigger: 'change',
      }">
                      <a-input class="rightSideinputText" :disabled="request.disabled" v-model="request.batchNumber" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="5">
                    <a-form-model-item label="Batch Expiry" :prop="'request.' + index + '.batchExpiry'" :rules="{
        required: true,
        message: 'Please select your option',
        trigger: 'change',
      }">
                      <a-date-picker class="rightSideinputText" v-model="request.batchExpiry"
                        :disabled="request.disabled" />
                    </a-form-model-item>
                  </a-col>
                  <a-col v-if="!request.disabled" :span="2">
                    <div style="
                        margin-top: 53px;
                        display: flex;
                        justify-content: space-around;
                      ">
                      <a-tooltip>
                        <template slot="title"> Remove this order? </template>
                        <a-icon v-if="addInventoryTransferModel.request.length > 0" class="dynamic-delete-button"
                          type="minus-circle-o" :disabled="addInventoryTransferModel.request.length === 0
        " @click="removeDomain(request)" />
                      </a-tooltip>
                    </div>
                  </a-col>
                  <a-col v-if="request.disabled" :span="2">
                    <div style="
                        margin-top: 53px;
                        display: flex;
                        justify-content: space-around;
                      ">
                      <a-tooltip>
                        <template slot="title"> Add this order? </template>
                        <a-icon v-if="addInventoryTransferModel.request.length > 0" type="plus" :disabled="addInventoryTransferModel.request.length === 0
        " @click="activateDomain(request)" />
                      </a-tooltip>
                    </div>
                  </a-col>
                </a-row>
              </div>

              <!-- <a-form-model-item class="pt-4">
                <a-button
                  :disabled="filteredProducts.length === 0"
                  style="
                    margin: 0 auto;
                    float: right;
                    background: #418a49;
                    color: #fff;
                  "
                  @click="addDomain"
                >
                  <a-icon type="plus" /> Add Product
                </a-button>
              </a-form-model-item> -->
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="Notes" ref="notes" prop="notes">
                    <a-textarea v-model="addInventoryTransferModel.notes" placeholder="Enter notes...."
                      :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-form-model-item style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  padding-top: 40px;
                ">
                <a-button @click="handleAddStockTransfer" :disabled="isEmptyOrder"
                  :class="[isEmptyOrder ? 'disbablesBtn' : 'activeBtn']">
                  Add Stock
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </a-spin>
      </a-modal>

      <!-- Add Inventory Transfer Model -->
      <a-modal class="modalStyle" :visible="addTransferVisible" width="800px" :footer="null"
        @cancel="handleAddTransferCancel">
        <a-spin :spinning="loading">
          <h4 style="
              display: flex;
              justify-content: center;
              padding-top: 10px;
              padding-bottom: 30px;
            ">
            Add Replenishment Request
          </h4>
          <add-inventory-transfer-form :locationId="wareHouseDetails.locationId"
            @inventoryRequest="handleAddInventoryTransfer"></add-inventory-transfer-form>
        </a-spin>
      </a-modal>
      <a-modal :visible="showConfirmModal" width="500px" :footer="null" title="Confirm Inventory Request"
        @cancel="handleCancelRequest">
        <a-form>
          <a-form-item label="Notes:">
            <a-textarea v-model="reasons" placeholder="Notes..."></a-textarea>
          </a-form-item>
        </a-form>
        <a-row type="flex" justify="space-between">
          <a-button type="primary" style="background: #418a49; color: #fff" @click="confirmAction">Confirm</a-button>
          <a-button type="danger" @click="handleCancelRequest">Cancel</a-button>
        </a-row>
      </a-modal>
      <a-modal :visible="confirmActionModal" width="500px" :footer="null" title="Confirm Action" @cancel="cancelAction">
        <a-spin :spinning="loading">
          <p :style="{ color: '#b3b3b3', textAlign: 'center', fontSize: '20px' }">
            Are you sure about this !!!
          </p>
          <a-row type="flex" justify="space-between">
            <a-button type="primary" style="background: #418a49" @click="handleConfirmRequest">Confirm</a-button>
            <a-button type="danger" @click="cancelAction">Cancel</a-button>
          </a-row>
        </a-spin>
      </a-modal>
    </div>
    <!-- Decline Order -->
    <a-modal class="modalStyle" :visible="isDeclinedVisible" :footer="null" @cancel="handleDeclinedCancel">
      <h3 style="text-align:center;font-weight: bolder;padding-top: 10px;">Decline Order <span style="color:#418a49">#{{
        orderNumber }}</span> ?</h3>
      <div>
        <p style="font-size:16px;text-align: center;">You are about to decline a new order [ <span
            style="color:#418a49">#{{
        orderNumber }}</span> ].</p>
      </div>

      <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:10px">
        <a-spin class="spinner" :spinning="declineLoading" />
      </div>
      <div style="display: flex;justify-content: center;">
        <a-button @click="handleDeclinedSubmit" style="background: #418a49;color:#fff;border-radius:5px;">
          Decline
        </a-button>
        <!-- <a-button @click="handleDeclinedCancel" style="background: red;color:#fff;border-radius:5px;">
                    Cancel
                </a-button> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import XLSX from "xlsx";
import { NotificationMixins } from "@/mixins/NotificationMixins";
import AddInventoryTransferForm from "./modals/AddInventoryTransferForm.vue";
import StatusComponent from "../shared-components/StatusComponent.vue";
const inventoryColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Product Name",
    dataIndex: "brandName",
    key: "brandName",
    scopedSlots: {
      filterDropdown: 'filterDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.brandName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "Product Category",
    dataIndex: "categoryName",
    key: "categoryName",
  },
  {
    title: "Product Supplier",
    dataIndex: "supplierName",
    key: "supplierName",
  },
  {
    title: "Product SKU",
    dataIndex: "sku",
    key: "sku",
  },
  {
    title: "Purchase Price(Ksh)",
    dataIndex: "purchasePrice",
    key: "purchasePrice",
  },
  {
    title: "Selling Price(Ksh)",
    dataIndex: "sellingPrice",
    key: "sellingPrice",
  },
  {
    title: "Product Quantity",
    dataIndex: "balance",
    key: "balance",
  },
  //   {
  //     title: "Inventory Value",
  //     dataIndex: "inventoryValue",
  //     key: "inventoryValue",
  //   },
];

const deliveryColumns = [
  {
    title: "Delivery ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Purchase Order ID",
    dataIndex: "clientPurchaseOrderId",
    key: "clientPurchaseOrderId",
    scopedSlots: { customRender: "clientPurchaseOrderId" },
  },
  {
    title: "Received By",
    dataIndex: "receivedBy",
    key: "receivedBy",
  },
  {
    title: "Product Count",
    dataIndex: "productCount",
    key: "productCount",
  },
  {
    title: "Received At",
    dataIndex: "createdAt",
    key: "createdAt",
  },

  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const transferColumns = [
  {
    title: "Id",
    // width: 150,
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Destination Name",
    dataIndex: "destinationLocationName",
    scopedSlots: {
      filterDropdown: 'filterDestinationDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.destinationLocationName
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    // width: 130,
  },

  {
    title: "Status",
    dataIndex: "status",
    // width: 150,
    scopedSlots: {
      customRender: "status",
      filterDropdown: 'filterStatusDropdown',
      filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
      record.status
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  },
  {
    title: "Date Created",
    dataIndex: "createdAt",
    key: "createdAt",
  },
  {
    title: "Action",
    dataIndex: "action",
    // width: 150,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "WareHouseDetails",
  components: {
    AddInventoryTransferForm,
    StatusComponent,
    InventoryReport: () => import('@/components/locations/tables/InventoryReports')
  },
  mixins: [NotificationMixins],
  data() {
    return {
      tableInventoryData: [],
      tableDeliveryData: [],
      tableTransferData: [],
      purchaseOrders: [],
      addInventoryTransferVisible: false,
      addTransferVisible: false,
      tableLoading: false,
      seletedPurchaseOrder: {},
      pagination: {
        pageSize: 20,
      },
      orderNumber: '',
      newOrderDetails: {},
      isDeclinedVisible: false,
      declineLoading: false,
      addInventoryTransferModel: {
        request: [
          //   {
          //     productId: "",
          //     quantity: "",
          //     batchNumber: "",
          //     batchExpiry: "",
          //     disabled: false,
          //     key: Date.now(),
          //   },
        ],
        purchaseOrderId: "",
        notes: "",
      },
      inventoryProducts: [],
      params: {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {},
      },
      availableTransfers: [],
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      selectedProduct: {},
      filteredProducts: [],
      availableProducts: [],
      wareHouseDetails: {},
      loading: false,
      inventoryColumns,
      deliveryColumns,
      transferColumns,
      completeOrCancelFulfillment: [],
      rules: {
        purchaseOrderId: [
          {
            required: true,
            message: "Please select your option",
            trigger: "change",
          },
        ],
      },
      showConfirmModal: false,
      confirmActionModal: false,
      currentRequest: {},
      reasons: "",
    };
  },
  methods: {
    ...mapActions([
      "getAllWarehouseMgtData",
      "setWareHouseDeliveryLinesInfo",
      "getClientProducts",
      "addStockToWarehouse",
      "addInventoryTransfer",
      "setWareHouseTransferLinesInfo",
      "setPreviewInfo",
      "declineNewOrder"
    ]),
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },
    onInventoryChange(value, clearFilters) {
      let result = []
      if (value === 'all') {
        result = this.availableTransfers
      } else {
        result = this.availableTransfers.filter(invoice => parseInt(invoice.status) === parseInt(value))
      }
      this.tableTransferData = result.map((transfer) => ({
        key: transfer.id,
        id: transfer.id,
        destinationLocationName: transfer.destinationLocationName
          ? transfer.destinationLocationName
          : "N/A",
        status: transfer.statusLabel ? transfer.statusLabel : "N/A",
        createdAt: moment(transfer.createdAt).format("DD-MM-YYYY HH:mm:ss"),
        action: transfer,
      }));
      clearFilters();

    },
    handleConfirm(data) {
      this.showConfirmModal = true;
      this.currentRequest = data;
    },
    showSuccessAlert(message) {
      this.$notification['success']({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification['error']({
        message: message
      });
    },
    handleDeclineRequest(data) {
      this.isDeclinedVisible = true
      this.orderNumber = data.id
      this.newOrderDetails = data
    },

    handleCompleteRequest(data) {
      this.completeOrCancelFulfillment = data.fulfillments.filter(request => request.status === 3 || request.status === 4) //check if the fullfilment status is Complete or Cnacel , then allow for Complete Request
      if (this.completeOrCancelFulfillment.length === data.fulfillments.length) {
        this.newOrderDetails = data
        this.handleCompleteOrder()
      } else {
        this.showErrorAlert("You have uncompleted fulfillment, Kindly fulfil them before completing them")
      }
    },

    handleDeclinedCancel() {
      this.isDeclinedVisible = false
    },
    handleCancelRequest() {
      this.showConfirmModal = false;
      this.currentRequest = {};
      this.reasons = "";
    },
    handleCompleteOrder() {
      // console.log("order data | ", this.newOrderDetails)
      let request = {
        inventoryRequestId: this.newOrderDetails.id,
        data: {
          status: 3
        }
      }
      // console.log("request | ", request)
      this.declineNewOrder(request).then(response => {
        if (response.status === 200) {
          this.getWarehouseMgtData()
          this.showSuccessAlert(`New Request [ #${this.newOrderDetails.id} ] Completed Successfully`)
        } else {
          this.showErrorAlert(response.data.messages)
        }
      }, error => {
        console.log("Error | ", error)
        this.showErrorAlert('Something went wrong, try again later.')
      })
    },
    handleDeclinedSubmit() {
      this.declineLoading = true
      // console.log("order data | ", this.newOrderDetails)
      let request = {
        inventoryRequestId: this.newOrderDetails.id,
        data: {
          status: 4
        }
      }
      // console.log("request | ", request)
      this.declineNewOrder(request).then(response => {
        this.declineLoading = false;
        if (response.status === 200) {
          this.getWarehouseMgtData()
          this.isDeclinedVisible = false
          this.showSuccessAlert(`New Request [ #${this.newOrderDetails.id} ] Declined Successfully`)
        } else {
          this.showErrorAlert(response.data.messages)
        }
      }, error => {
        this.declineLoading = false
        console.error("Error | ", error)
        this.showErrorAlert('Something went wrong, try again later.')
      })
    },
    async handleConfirmRequest() {
      this.loading = true;
      const payload = {
        notes: this.reasons,
        InventoryRequestId: this.currentRequest.id,
      };
      try {
        const res = await this.$store.dispatch(
          "distroCenter/ConfirmInventoryRequest",
          payload
        );
        if (res) {
          this.showSuccessAlert("Inventory transfer confirmed");
          this.loading = false;
          this.showConfirmModal = false;
          this.confirmActionModal = false;
          this.getWarehouseMgtData();
        }
      } catch (error) {
        // console.log("Error=> ", error)
      }
    },
    confirmAction() {
      this.showConfirmModal = false;
      this.confirmActionModal = true;
    },
    cancelAction() {
      this.confirmActionModal = false;
    },
    showAddInventoryTransferModal() {
      this.addInventoryTransferVisible = true;
    },

    handleAddStockTransferCancel() {
      this.addInventoryTransferVisible = false;
    },

    showAddTransferModal() {
      this.addTransferVisible = true;
    },
    handleAddTransferCancel() {
      this.addTransferVisible = false;
    },

    handleAddGroupCancel() {
      this.addGroupVisible = false;
    },

    redirectToPurchaseOrderSingle(data) {
      const purchaseOrder = this.purchaseOrders.find(
        (order) => order.id == data.clientPurchaseOrderId
      );
      const purchaseOrders = purchaseOrder.purchaseOrderLines.map((order) => ({
        key: order.id,
        id: order.id,
        name: order.productName,
        category: order.categoryName ? order.categoryName : "",
        quantity: order.quantity.toString(),
        unitPrice: order.price.toString(),
        lineTotal: parseInt(order.quantity) * parseInt(order.price),
      }));
      let previewData = {
        discount: purchaseOrder.discount,
        purchaseOrderId: purchaseOrder.id,
        deliveryDate: moment(purchaseOrder.deliveryDate).format(),
        supplierName: purchaseOrder.supplierName,
        supplierId: purchaseOrder.supplierId,
        supplierAddress: purchaseOrder.supplierAddress,
        supplierCity: "",
        supplierCountry: "",
        destionation: "",
        sellerAddress: purchaseOrder.sellerAddress,
        shipCity: "",
        shipCountry: "",
        shippingMethodLabel: purchaseOrder.shippingMethodLabel,
        shippingMethod: purchaseOrder.shippingMethod,
        shippinTerm: purchaseOrder.terms,
        tableData: purchaseOrders,
        action: "edit",
        statusLabel: purchaseOrder.statusLabel,
        deleiveries: purchaseOrder.inventoryDeliveries,
      };
      // console.log("previewData | ", previewData)
      this.setPreviewInfo(JSON.stringify(previewData));
      this.$router
        .push({
          name: "purchase-order-invoice",
        })
        .catch(() => { });
    },

    handleAddStockTransfer() {
      this.$refs.addInventoryTransferForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let productQuantity = [];

          const confirmedOrder = this.addInventoryTransferModel.request.filter(
            (order) => order.disabled === false
          );

          confirmedOrder.forEach((product) => {
            productQuantity.push({
              productId: product.productId,
              quantity: product.quantity,
              batchNumber: product.batchNumber.toUpperCase(),
              batchExpiry: moment(product.batchExpiry).format(),
            });
          });

          const request = {
            id: this.wareHouseDetails.id,
            data: {
              productLines: productQuantity,
              notes: this.addInventoryTransferModel.notes,
              clientPurchaseOrderId:
                this.addInventoryTransferModel.purchaseOrderId,
            },
          };

          //   console.log("request | ", request);

          const response = await this.addStockToWarehouse(request);
          this.loading = false;
          if (response.status === 200) {
            this.addInventoryTransferVisible = false;
            this.showSuccessAlert("New Stock Received Successfully");
            this.getWarehouseMgtData();
          } else {
            // // console.log("Error | ", response);
          }
        } else {
          return false;
        }
      });
    },
    handleAddInventoryTransfer(data) {
      this.loading = true;
      this.addInventoryTransfer(data).then(
        (response) => {
          this.loading = false;
          if (response.status === 200) {
            // this.loadBackOrdersData();
            this.showSuccessAlert("New Inventory Tranfered Successfully");
            this.addTransferVisible = false;
            this.getWarehouseMgtData()
          } else {
            this.showErrorAlert(response.data.messages);
          }
        },
        (error) => {
          this.loading = false;
          this.showErrorAlert(JSON.stringify(error));
        }
      );
    },
    addDomain() {
      this.$refs.addInventoryTransferForm.validate((valid) => {
        if (valid) {
          this.checkExistingProducts();
          if (this.filteredProducts.length !== 0) {
            this.addInventoryTransferModel.request.push({
              productId: "",
              quantity: "",
              batchNumber: "",
              batchExpiry: "",
              disabled: false,
              productName: "",
              key: Date.now(),
            });
            this.scrollToEnd();
          }
        } else {
          return false;
        }
      });
    },
    scrollToEnd: function () {
      const container = this.$refs.productHeight;
      container.scrollTop = container.scrollHeight;
    },
    removeDomain(item) {
      let index = this.addInventoryTransferModel.request.indexOf(item);
      if (index !== -1) {
        // this.addInventoryTransferModel.request.splice(index, 1);
        this.addInventoryTransferModel.request[index].disabled = true;
        this.addInventoryTransferModel.request[index].required = false
      }
      this.checkExistingProducts();
    },
    activateDomain(item) {
      let index = this.addInventoryTransferModel.request.indexOf(item);
      if (index !== -1) {
        // this.addInventoryTransferModel.request.splice(index, 1);
        this.addInventoryTransferModel.request[index].disabled = false;
        this.addInventoryTransferModel.request[index].required = true;
      }
      this.checkExistingProducts();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeQuantity(quantity) {
      // console.log("quantity | ", quantity)
      if (_.isEmpty(this.selectedProduct)) {
        this.showErrorAlert("Kindly select product");
      } else {
        // console.log("selectedProduct | ", this.selectedProduct)
        if (!(quantity <= this.selectedProduct.balance)) {
          this.showErrorAlert(
            `You've exceeded the quantity. Kindly choose between 1 to ${this.selectedProduct.balance}`
          );
        }
      }
    },

    onPurchaseOrder(id) {
      const purchaseOrder = this.purchaseOrders.find(
        (order) => order.id === id
      );
      this.seletedPurchaseOrder = purchaseOrder;
      this.addInventoryTransferModel.request =
        purchaseOrder.purchaseOrderLines.map((order) => ({
          productId: order.productId,
          quantity: order.quantity,
          batchNumber: "",
          productName: order.productName,
          batchExpiry: moment().format(),
          disabled: false,
          required: true,
          key: order.productId,
        }));
    },

    checkExistingProducts() {
      const selectedProducts = this.addInventoryTransferModel.request.map(
        (product) => product.productId
      );
      const products = [];
      this.availableProducts.forEach((product) => {
        if (!selectedProducts.includes(product.id)) {
          products.push(product);
        }
      });
      this.filteredProducts = products;
    },
    onChangeProduct(productId) {
      const product = this.filteredProducts.find(
        (product) => product.id === productId
      );
      if (product) {
        this.selectedProduct = product;
      }
    },

    showGroupModal() {
      this.addGroupVisible = true;
    },

    showSupplierModal() {
      this.addSupplierVisible = true;
    },
    handleAddGroupSubmit() {
      this.$refs.addGroupForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const request = {
            name: this.addGroupModel.name,
            description: this.addGroupModel.description,
          };

          this.addNewGroup(request).then(
            (response) => {
              this.loading = false;
              if (response.status === 200) {
                this.getProductsMgtData();
                this.showSuccessAlert("New Group Added Successfully");
                this.$refs.addGroupForm.resetFields();
                this.addGroupVisible = false;
              } else {
                this.showErrorAlert(response.data.messages);
              }
            },
            (error) => {
              this.loading = false;
              this.showErrorAlert(JSON.stringify(error));
            }
          );
        }
      });
    },

    showDeliveryLines(data) {
      this.setWareHouseDeliveryLinesInfo(data);
      this.$router
        .push({
          name: "warehouse-details-lines",
          params: { locationId: data.id },
        })
        .catch(() => { });
    },
    showTransfersLines(data) {
      this.setWareHouseTransferLinesInfo(data);
      this.$router
        .push({
          name: "warehouse-transfers-lines",
          params: { transferId: data.id },
        })
        .catch(() => { });
    },
    exportExcell() {
      const dataToExport = [
        [
          "ID",
          "Product Name",
          "Product Category",
          "Product SKU",
          "Purchase Price(Ksh)",
          "Selling Price(Ksh)",
          "Product Quantity",
        ],
      ];

      this.tableInventoryData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.brandName,
          v.categoryName,
          v.sku,
          v.purchasePrice,
          v.sellingPrice,
          v.balance,
        ]);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Warehouse-Inventory-Report-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.exportLoading = false;
      this.showSuccessAlert("Data Successfully Exported");
    },

    exportDelivery() {
      const dataToExport = [
        ["Delivery ID", "Received By", "Product Count", "Received At"],
      ];

      this.tableDeliveryData.forEach((v) => {
        dataToExport.push([v.id, v.receivedBy, v.productCount, v.createdAt]);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Warehouse-Delivery-Report-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.exportLoading = false;
      this.showSuccessAlert("Data Successfully Exported");
    },

    exportTransfer() {
      const dataToExport = [
        ["Transfer ID", "Destination", "Status", "Created At"],
      ];

      this.tableTransferData.forEach((v) => {
        dataToExport.push([
          v.id,
          v.destinationLocationName,
          v.status,
          v.createdAt,
        ]);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Warehouse-Transfer-Report-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.exportLoading = false;
      this.showSuccessAlert("Data Successfully Exported");
    },
    getAllInventoryData(response) {
      if (response.status === 200) {
        this.tableInventoryData = response.data.data.map((inventory) => ({
          key: inventory.id,
          id: inventory.id,
          brandName: inventory.brandName,
          categoryName: inventory.categoryName,
          supplierName: inventory.supplierName,
          sku: inventory.sku,
          purchasePrice: inventory.purchasePrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          sellingPrice: inventory.sellingPrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          balance: inventory.balance,
        }));
      } else {
        // // console.log("Error | ", response);
      }
    },
    getAllDeliveriesData(response) {
      if (response.status === 200) {
        this.tableDeliveryData = response.data.data.map((delivery) => ({
          key: delivery.id,
          id: delivery.id,
          clientPurchaseOrderId: delivery,
          receivedBy: delivery.receivedBy ? delivery.receivedBy : "N/A",
          productCount: delivery.deliveryLines.length,
          createdAt: moment(delivery.createdAt).format("DD-MM-YYYY HH:mm:ss"),
          action: delivery,
        }));
      } else {
        // // console.log("Error | ", response);
      }
    },

    getAllTransferData(response) {
      if (response.status === 200) {
        this.availableTransfers = response.data.data
        this.tableTransferData = response.data.data.map((transfer) => ({
          key: transfer.id,
          id: transfer.id,
          destinationLocationName: transfer.destinationLocationName
            ? transfer.destinationLocationName
            : "N/A",
          status: transfer.statusLabel ? transfer.statusLabel : "N/A",
          createdAt: moment(transfer.createdAt).format("DD-MM-YYYY HH:mm:ss"),
          action: transfer,
        }));
      } else {
        // // console.log("Error | ", response);
      }
    },

    setAvailableProducts(response) {
      if (response.status === 200) {
        this.availableProducts = response.data.data;
        this.filteredProducts = response.data.data;
      } else {
        // console.log("Error | ", response);
      }
    },

    getPurchaseOrderHistory(response) {
      if (response.status === 200) {
        this.purchaseOrders = response.data.data;
      } else {
        // console.log("Error | ", response);
      }
    },

    displayDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    async getWarehouseMgtData() {
      this.tableLoading = true;
      const response = await this.getAllWarehouseMgtData(
        this.wareHouseDetails.locationId
      );
      const result = await this.getClientProducts(this.params);
      this.setAvailableProducts(result);
      this.getAllInventoryData(response[0]);
      this.getAllDeliveriesData(response[1]);
      this.getAllTransferData(response[2]);
      this.getPurchaseOrderHistory(response[3]);

      this.tableLoading = false;
    },
  },
  computed: {
    ...mapGetters(["getWareHouseInfo"]),
    isEmptyOrder() {
      const confirmedOrder = this.addInventoryTransferModel.request.filter(
        (order) => order.disabled === false
      );
      return _.isEmpty(confirmedOrder);
    },
  },
  created() {
    if (this.getWareHouseInfo) {
      this.wareHouseDetails = this.getWareHouseInfo;
      this.getWarehouseMgtData();
    }
  },
};
</script>

<style scoped>
.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.actions {
  display: flex;
  justify-content: space-between;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}

.card-container>>>.ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle>>>.ant-modal-header {
  border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
  border-top: none;
}

.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container>>>.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner>>>.ant-spin-dot-item {
  background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
  border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

.orderTable>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.orderTable>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.orderTable>>>.ant-pagination-item-active a {
  color: #fff;
}

.orderTable>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.numberInput {
  width: 100%;
  border-radius: 5px;
}

.spinner>>>.ant-spin-dot-item {
  background-color: #418a49;
}

.orderTable>>>.ant-spin-dot-item {
  background-color: #418a49;
}

.ant-switch-checked {
  background-color: #418a49;
}

.disbablesBtn {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
  height: 38px;
  border-radius: 5px;
}

.activeBtn {
  height: 38px;
  margin-right: 10px;
  border-radius: 5px;
  background: #418a49;
  color: #fff;
}

.rightSideinputText {
  width: 100%;
  border-radius: 5px;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar {
  border: none;
}

.card-container>>>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  height: 40px;
  color: #111827;
  background: transparent;
  border-radius: 8px;
  max-width: 15%;
  margin-right: 12px;
}


.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #fff;
  background: #418a49;
  border-bottom: none;
  border-radius: 8px;
  max-width: 15%;
}
</style>